// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-button{position:absolute;display:flex;flex-direction:column;cursor:pointer}[dir=ltr] .share-button{right:0}[dir=rtl] .share-button{left:0}.share-buttons{min-width:79px;align-self:start;padding-top:.5em}.share-buttons__container{display:flex;flex-direction:row;justify-content:flex-end;font-size:16px}.share-buttons__button{cursor:pointer}.share-buttons__button:not(:first-of-type){margin-inline-start:16px}", ""]);
// Exports
module.exports = exports;
